// extracted by mini-css-extract-plugin
export default {"counterInputContainer":"CounterInput_counterInputContainer__rYBTK"};